/*
 * Умный поиск WAU в выпадающем списке (docs/assistant/03-smart-search.md).
 *
 * Штатный поиск Sleek работает как раньше и рисует выдачу сразу. Затем этот
 * модуль спрашивает помощника на wau.ru и, если тот ответил вовремя, заменяет
 * список товаров своим: по смыслу, с ценой рынка покупателя. Не ответил за
 * 2,5 с, ответил пусто или с ошибкой — остаётся штатная выдача, без сообщений.
 *
 * Пилот: доля посетителей из настройки темы, по стабильному номеру в
 * localStorage. Без localStorage — штатный поиск.
 */
(function () {
  'use strict';

  var cfg = window.WAUSearchConfig;
  if (!cfg || !cfg.api) {
    return;
  }

  // Штатная выдача уже на экране, поэтому ждать помощника можно дольше, чем
  // пустое окно: 2,5 с с запасом на путь до сервера и обратно.
  var TIMEOUT = 2500;
  var MIN_LENGTH = 3;
  var cache = new Map();

  function bucket() {
    try {
      var value = localStorage.getItem('wau_search_bucket');
      if (value === null) {
        value = String(Math.floor(Math.random() * 100));
        localStorage.setItem('wau_search_bucket', value);
      }
      return Number(value);
    } catch (e) {
      return 100;
    }
  }

  var enabled = bucket() < Number(cfg.pilot || 0);

  function request(query) {
    if (cache.has(query)) {
      return cache.get(query);
    }
    // Через App Proxy витрины: сервер в России открывается не везде.
    var url = (cfg.proxy || cfg.api.replace(/\/$/, '')) + '/search/?' + new URLSearchParams({
      q: query,
      locale: cfg.locale || 'en',
      country: cfg.country || 'US'
    }).toString();
    var controller = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () {
      if (controller) controller.abort();
    }, TIMEOUT);
    var pending = fetch(url, { credentials: 'omit', signal: controller ? controller.signal : undefined })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .catch(function () {
        cache.delete(query);
        return null;
      })
      .finally(function () {
        clearTimeout(timer);
      });
    cache.set(query, pending);
    return pending;
  }

  function money(amount, currency) {
    try {
      return new Intl.NumberFormat(cfg.locale || undefined, { style: 'currency', currency: currency, maximumFractionDigits: 2 }).format(amount);
    } catch (e) {
      return amount + ' ' + currency;
    }
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = String(text == null ? '' : text);
    return div.innerHTML;
  }

  function item(product, index) {
    var image = product.image
      ? '<a href="' + escapeHtml(product.url) + '" class="media-wrapper blocks-radius-sm" data-wau-search-click>'
        + '<img src="' + escapeHtml(product.image + (product.image.indexOf('?') < 0 ? '?' : '&') + 'width=150') + '" alt="" width="100" loading="lazy" is="image-lazy" class="motion-reduce"></a>'
      : '';
    var price = '<div class="price flex flex-wrap items-center gap-2">'
      + '<span class="price__regular">' + escapeHtml(money(product.price, product.currency)) + '</span>'
      + (product.compareAt ? '<s class="price__compare text-subtext">' + escapeHtml(money(product.compareAt, product.currency)) + '</s>' : '')
      + '</div>';

    return '<li id="predictive-search-option-product-' + (index + 1) + '" class="predictive-search__list-item wau-search__item" role="option" aria-selected="false">'
      + '<div class="flex items-center gap-3">' + image
      + '<div class="grid gap-1"><p class="block m-0"><a href="' + escapeHtml(product.url) + '" class="reversed-link text-pcard-title" data-wau-search-click>'
      + escapeHtml(product.title) + '</a></p>' + price + '</div></div></li>';
  }

  function render(target, data) {
    var html = data.products.map(item).join('');
    var list = target.querySelector('#predictive-search-results-products-list');
    if (list) {
      var ul = document.createElement('ul');
      ul.id = 'predictive-search-results-products-list';
      ul.className = 'grid gap-4 wau-search__list';
      ul.setAttribute('role', 'group');
      ul.innerHTML = html;
      list.replaceWith(ul);
      return;
    }
    // Штатный поиск ничего не нашёл («gerät gegen falten») — вместо пустого
    // состояния показываем товары помощника.
    var empty = target.querySelector('.empty-state');
    var block = '<div class="grid predictive-search-result search__box-item predictive-search-result--products gap-3">'
      + '<h4 class="predictive-search-result__heading h5">' + escapeHtml(cfg.labels.products) + '</h4>'
      + '<ul id="predictive-search-results-products-list" class="grid gap-4 wau-search__list" role="group">' + html + '</ul></div>';
    if (empty) {
      var wrap = document.createElement('div');
      wrap.className = 'grid gap-6 w-full';
      wrap.innerHTML = block;
      empty.replaceWith(wrap);
    }
  }

  function track(name, params) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, params);
    } else if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: name }, params));
    }
  }

  window.WAUSearch = {
    enabled: enabled,
    enhance: function (form, target, query) {
      if (!enabled || !target || !query || query.length < MIN_LENGTH) {
        return;
      }
      var seq = (form.__wauSeq || 0) + 1;
      form.__wauSeq = seq;
      target.setAttribute('aria-busy', 'true');
      request(query).then(function (data) {
        target.removeAttribute('aria-busy');
        // Пока ждали, покупатель мог дописать запрос — старый ответ не нужен.
        if (form.__wauSeq !== seq || form.getQuery() !== query) {
          return;
        }
        if (!data || !data.enabled || data.fallback || !data.products || !data.products.length) {
          return;
        }
        render(target, data);
        target.querySelectorAll('[data-wau-search-click]').forEach(function (link) {
          link.addEventListener('click', function () {
            track('wau_search_result_click', { search_term: query });
          });
        });
      });
    }
  };
})();
